import { useEffect } from "react";
import Nav from "@/sections/Nav";
import Footer from "@/sections/Footer";
import { Chapter } from "@/components/Chapter";
import { Reveal } from "@/components/Reveal";

const LegalShell = ({ title, children }) => (
  <div className="bg-white text-ink font-sans antialiased min-h-screen">
    <Nav />
    <main className="pt-36 pb-24">
      <div className="mx-auto max-w-3xl px-6">
        <Chapter eyebrow="Legal" title={title} />
        <Reveal>
          <div className="space-y-6 text-sm md:text-base text-steel leading-relaxed">{children}</div>
        </Reveal>
      </div>
    </main>
    <Footer />
  </div>
);

export function PrivacyPage() {
  useEffect(() => {
    document.title = "Privacy — WSafe AI by WorkSafeAgent";
  }, []);
  return (
    <LegalShell title="Privacy Policy">
      <p>WorkSafeAgent LLC ("we", "us") is based in Abilene, Texas. This policy covers this website.</p>
      <p>
        <strong className="text-navy">What we collect.</strong> When you contact us through a form, we
        collect the name, work email, company and message you provide. We use standard, privacy-respecting
        analytics to understand aggregate site usage.
      </p>
      <p>
        <strong className="text-navy">How we use it.</strong> Only to respond to your enquiry and to
        operate and improve this site. We do not sell personal information.
      </p>
      <p>
        <strong className="text-navy">Retention &amp; rights.</strong> We keep contact records as long as
        needed to handle your enquiry. To access, correct or delete your information, email{" "}
        <a href="mailto:info@wsafeai.com" className="text-safety hover:underline">info@wsafeai.com</a>.
      </p>
    </LegalShell>
  );
}

export function TermsPage() {
  useEffect(() => {
    document.title = "Terms — WSafe AI by WorkSafeAgent";
  }, []);
  return (
    <LegalShell title="Terms of Use">
      <p>This website is operated by WorkSafeAgent LLC, Abilene, Texas. By using it you accept these terms.</p>
      <p>
        <strong className="text-navy">Informational content.</strong> Content on this site is general
        information, not safety, legal or compliance advice for your specific site. AI outputs described here
        are suggestions reviewed by a person.
      </p>
      <p>
        <strong className="text-navy">Intellectual property.</strong> Site content and the WSafe product
        names are the property of WorkSafeAgent LLC. Patent pending.
      </p>
      <p>
        <strong className="text-navy">Contact.</strong> Questions about these terms:{" "}
        <a href="mailto:info@wsafeai.com" className="text-safety hover:underline">info@wsafeai.com</a>.
      </p>
    </LegalShell>
  );
}
